import React from "react";
import ListEditor from "../ListEditor";
import { adminApi } from "../../lib/api";
import { Label, TextInput, TextArea, NumberInput, Switch, ImageUploader } from "../FormControls";

const newEdu = () => ({
  school: "",
  degree: "",
  period: "",
  location: "",
  gpa: "",
  notes: "",
  logo_url: "",
  visible: true,
  order: 0,
});

const Education = () => (
  <ListEditor
    resource={adminApi.education}
    resourceKey="education"
    title="Education"
    newItem={newEdu}
    searchFields={["school", "degree"]}
    renderRow={(e) => (
      <div className="min-w-0">
        <div className="text-white font-medium truncate">{e.school}</div>
        <div className="text-xs text-slate-500 truncate">{e.degree} · {e.period} · {e.gpa}</div>
      </div>
    )}
    renderForm={(d, set) => (
      <>
        <div>
          <Label>School</Label>
          <TextInput value={d.school} onChange={(v) => set("school", v)} />
        </div>
        <div className="grid sm:grid-cols-2 gap-3">
          <div>
            <Label>Degree</Label>
            <TextInput value={d.degree} onChange={(v) => set("degree", v)} />
          </div>
          <div>
            <Label>Period</Label>
            <TextInput value={d.period} onChange={(v) => set("period", v)} />
          </div>
        </div>
        <div className="grid sm:grid-cols-2 gap-3">
          <div>
            <Label>Location</Label>
            <TextInput value={d.location} onChange={(v) => set("location", v)} />
          </div>
          <div>
            <Label>GPA / CPI</Label>
            <TextInput value={d.gpa} onChange={(v) => set("gpa", v)} />
          </div>
        </div>
        <div>
          <Label>Notes</Label>
          <TextArea value={d.notes} onChange={(v) => set("notes", v)} rows={3} />
        </div>
        <div>
          <Label>School logo</Label>
          <ImageUploader value={d.logo_url} onChange={(v) => set("logo_url", v)} />
        </div>
        <div className="flex items-center gap-6">
          <Switch value={d.visible} onChange={(v) => set("visible", v)} label="Visible" />
          <div className="flex items-center gap-2 ml-auto">
            <Label>Order</Label>
            <NumberInput value={d.order} onChange={(v) => set("order", v)} />
          </div>
        </div>
      </>
    )}
  />
);

export default Education;
